import React from "react"

export default function AnalyzingStep({ t, profile }) {
  const current = profile?.crawl_progress_current ?? 0
  const phases = [
    t("dashboard.onboarding.analyzing.phase_render"),
    t("dashboard.onboarding.analyzing.phase_locale"),
    t("dashboard.onboarding.analyzing.phase_ai"),
    t("dashboard.onboarding.analyzing.phase_save"),
    t("dashboard.onboarding.analyzing.phase_selectors"),
    t("dashboard.onboarding.analyzing.phase_facts"),
    t("dashboard.onboarding.analyzing.phase_screenshot"),
    t("dashboard.onboarding.analyzing.phase_vision")
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span aria-hidden className="inline-block w-2 h-2 rounded-full bg-ai animate-pulse" />
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.onboarding.analyzing.title")}
        </h1>
      </div>

      <p className="text-sm text-ink-secondary leading-relaxed">
        {t("dashboard.onboarding.analyzing.lede")}
      </p>

      <ol className="border-t border-rule">
        {phases.map((label, i) => {
          const state = i < current ? "done" : i === current ? "active" : "pending"
          const dot =
            state === "done"
              ? "bg-winner-dot"
              : state === "active"
              ? "bg-ai animate-pulse"
              : "bg-rule"
          const text =
            state === "done"
              ? "text-ink-secondary"
              : state === "active"
              ? "text-ink-primary"
              : "text-ink-faint"
          return (
            <li
              key={label}
              className="grid grid-cols-[20px_minmax(0,1fr)_auto] gap-4 py-3 border-b border-rule items-center"
            >
              <span aria-hidden className={`inline-block w-2 h-2 rounded-full ${dot}`} />
              <span className={`text-sm ${text}`}>{label}</span>
              <span
                className="font-mono text-[10px] tracking-[0.12em] text-ink-tertiary"
                style={{ fontVariantNumeric: "tabular-nums" }}
              >
                {state === "done" ? "DONE" : state === "active" ? "WORKING" : ""}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
